import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { setSnackbarRef } from "@/utils/toastService";

// This component initializes the toast service with the snackbar ref
// Add it inside SnackbarProvider in index.tsx
const ToastServiceInit = () => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setSnackbarRef(enqueueSnackbar);
  }, [enqueueSnackbar]);

  return null;
};

export default ToastServiceInit;
